var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchGray300Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4666 10.5333L14.4666 13.5333C14.7333 13.8 14.7333 14.2 14.4666 14.4666C14.3333 14.6 14.1333 14.6666 13.9999 14.6666C13.8666 14.6666 13.6666 14.6 13.5333 14.4666L10.5333 11.4666C9.53325 12.2 8.33325 12.6666 6.99992 12.6666C3.86659 12.6666 1.33325 10.1333 1.33325 6.99998C1.33325 3.86665 3.86659 1.33331 6.99992 1.33331C10.1333 1.33331 12.6666 3.86665 12.6666 6.99998C12.6666 8.33331 12.1999 9.59998 11.4666 10.5333ZM6.99992 2.66665C4.59992 2.66665 2.66659 4.59998 2.66659 6.99998C2.66659 9.39998 4.59992 11.3333 6.99992 11.3333C8.19992 11.3333 9.26659 10.8666 10.0666 10.0666C10.8666 9.26665 11.3333 8.19998 11.3333 6.99998C11.3333 4.59998 9.39992 2.66665 6.99992 2.66665Z",
    fill: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7828_2382",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4666 10.5333L14.4666 13.5333C14.7333 13.8 14.7333 14.2 14.4666 14.4666C14.3333 14.6 14.1333 14.6666 13.9999 14.6666C13.8666 14.6666 13.6666 14.6 13.5333 14.4666L10.5333 11.4666C9.53325 12.2 8.33325 12.6666 6.99992 12.6666C3.86659 12.6666 1.33325 10.1333 1.33325 6.99998C1.33325 3.86665 3.86659 1.33331 6.99992 1.33331C10.1333 1.33331 12.6666 3.86665 12.6666 6.99998C12.6666 8.33331 12.1999 9.59998 11.4666 10.5333ZM6.99992 2.66665C4.59992 2.66665 2.66659 4.59998 2.66659 6.99998C2.66659 9.39998 4.59992 11.3333 6.99992 11.3333C8.19992 11.3333 9.26659 10.8666 10.0666 10.0666C10.8666 9.26665 11.3333 8.19998 11.3333 6.99998C11.3333 4.59998 9.39992 2.66665 6.99992 2.66665Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7828_2382)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGray300Icon);
export default __webpack_public_path__ + "static/media/search_gray300_icon.c9850212205eae4293a8330ffe2b8bf0.svg";
export { ForwardRef as ReactComponent };